<template>
  <div class="wrap">
    <car-headerbar :title="'创建问卷'" />
    <CarDynamicForm
      ref="demoDynamicForm"
      :model="model"
      :options="options"
      @onFailed="onFailed"
      @onSubmit="onSubmitFn"
    >
      <template #footer>
        <me-button round block type="info" native-type="submit">提交</me-button>
      </template>
    </CarDynamicForm>
    <!-- 模拟获取表单数据-->
    <me-button type="primary" block>+添加题目</me-button>
    <me-tabbar v-model="active" class="tabbar">
        <me-tabbar-item name="home" icon="add-o" @click="add">题目</me-tabbar-item>
        <me-tabbar-item name="search" icon="setting-o" @click="setting">设置</me-tabbar-item>
        <me-tabbar-item name="friends" icon="eye-o" @click="preview">预览</me-tabbar-item>
        <me-tabbar-item name="setting" icon="play-circle-o" @click="publish">发布</me-tabbar-item>
    </me-tabbar>
  </div>
</template>

<script>
import formItem from '../compontents/form_item'

let exampleData = { 'code': 0, 'message': '请求并执行成功', 'data': '{"form":{"button":{"disabled":false,"text":"保存","api":"submit"},"title":"基本信息","groupData":[{"items":[{"code":"PERSONAL_INFO_GROUP","label":"个人信息","type":"group","items":[{"code":"CURRENT_RESIDENCE_PROVINCE_CITY","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"现居住地","type":"region","value":[]},{"code":"CURRENT_RESIDENCE_SPECIFIC","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"","type":"input","value":""},{"code":"MARITAL_STATUS","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"婚姻状况","type":"select","value":""}]},{"code":"CONTACT_INFO_GROUP","label":"联系人信息","type":"group","items":[{"code":"FIRST_CONTACT_NAME","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"第一联系人姓名","type":"input","value":""},{"code":"FIRST_CONTACT_TYPE","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"与联系人关系","type":"select","value":""},{"code":"FIRST_CONTACT_PHONE","editable":true,"dataType":"","description":"信审材料-第一联系人手机号","decryptionType":"encrypt","rules":["required"],"label":"联系人手机号","type":"jr-decryption","decryptionDataType":1,"limit":1,"inputType":"number","disabled":false,"value":{"auto":1,"appkey":"eipis-user","text":"***********","key":""}},{"code":"SECOND_CONTACT_NAME","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"第二联系人姓名","type":"input","value":""},{"code":"SECOND_CONTACT_TYPE","dataType":"","limit":1,"disabled":false,"rules":["required"],"label":"与联系人关系","type":"select","value":""},{"code":"SECOND_CONTACT_PHONE","editable":true,"dataType":"","description":"信审材料-联系人手机号","decryptionType":"encrypt","rules":["required"],"label":"联系人手机号","type":"jr-decryption","decryptionDataType":1,"limit":1,"inputType":"number","disabled":false,"value":{"auto":1,"appkey":"eipis-user","text":"***********","key":""}}]}]}]},"api":{"request":{"submit":{"dataKey":"","extend":{"apply_id":"$query.apply_id","page_path":"$query.page_path","source_type":"$query.source_type"},"url":"/api/v1/material/submit","methed":"POST"}}},"sourceData":{"CURRENT_RESIDENCE_SPECIFIC":{"material_type":1,"code":"CURRENT_RESIDENCE_SPECIFIC","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":""},"SECOND_CONTACT_NAME":{"material_type":1,"code":"SECOND_CONTACT_NAME","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":"第二联系人姓名"},"FIRST_CONTACT_PHONE":{"material_type":1,"code":"FIRST_CONTACT_PHONE","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":"联系人手机号"},"MARITAL_STATUS":{"material_type":2,"code":"MARITAL_STATUS","file_type":0,"option_list":[{"children":[],"text":"未婚","value":"1"},{"children":[],"text":"已婚","value":"2"},{"children":[],"text":"离异","value":"3"},{"children":[],"text":"丧偶","value":"4"}],"data_type":"int","input_type":1,"label":"婚姻状况"},"CURRENT_RESIDENCE_PROVINCE_CITY":{"material_type":1,"code":"CURRENT_RESIDENCE_PROVINCE_CITY","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":"现居住地"},"FIRST_CONTACT_NAME":{"material_type":1,"code":"FIRST_CONTACT_NAME","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":"第一联系人姓名"},"FIRST_CONTACT_TYPE":{"material_type":2,"code":"FIRST_CONTACT_TYPE","file_type":0,"option_list":[{"children":[],"text":"配偶","value":"1"},{"children":[],"text":"父母","value":"2"},{"children":[],"text":"子女","value":"7"},{"children":[],"text":"其他亲属","value":"4"}],"data_type":"int","input_type":1,"label":"与联系人关系"},"SECOND_CONTACT_TYPE":{"material_type":2,"code":"SECOND_CONTACT_TYPE","file_type":0,"option_list":[{"children":[],"text":"男女朋友","value":"11"},{"children":[],"text":"朋友","value":"5"},{"children":[],"text":"同事","value":"6"},{"children":[],"text":"亲属","value":"10"}],"data_type":"int","input_type":1,"label":"与联系人关系"},"SECOND_CONTACT_PHONE":{"material_type":1,"code":"SECOND_CONTACT_PHONE","file_type":0,"option_list":[],"data_type":"string","input_type":0,"label":"联系人手机号"}}}' }

export default {
    name: 'dynamicForm',
    data() {
        return {
            active: 'home',
            model: {
            },
            options: {
                props: { // 表单props配置
                    'validate-first': true,
                    'scroll-to-error': true,
                    'show-error-message': false,
                },
                controls: [],
            },
        }
    },
    components: {
        formItem,
    },
    created() {
        this.parseData()
    },
    methods: {
        add() {},
        setting() {
            this.$router.push({
                name: 'setting',
            })
        },
        preview() {
            this.$router.push({
                name: 'preview',
                params: {
                    pageId: 1,
                },
            })
        },
        publish() {},
        parseData() {
            let data = JSON.parse(exampleData.data).form.groupData[0].items
            let { sourceData } = JSON.parse(exampleData.data)
            console.log('---1---', JSON.parse(exampleData.data))
            let controls = []
            data.forEach((item) => {
                // console.log(item)
                let _item = item
                for (let i = 0; i < _item.items.length; i++) {
                    let o = _item.items[i]
                    switch (o.type) {
                        case 'select':
                            _item.items[i] = {
                                type: 'component',
                                component: formItem,
                                code: o.code,
                                label: o.label,
                                props: {
                                    columns: sourceData[o.code].option_list,
                                },

                            }
                            break
                        default:
                            _item.items[i] = {
                                type: 'text',
                                code: o.code,
                                label: o.label,
                            }
                    }

                }
                // console.log(_item.items)
                controls.push(_item)
            })
            this.options.controls = controls
        },
        onSubmitFn(res) {
            // {"textInput1":"","name1":"11","SECOND_CONTACT_PHONE":"","name":"22","name2122":"","sex":1,"FIRST_CONTACT_TYPE":"","FIRST_CONTACT_TYPE2":""}
            console.log('onSubmitFnonSubmitFnonSubmitFn', res)
        },
        onFailed(errorInfo) {
            // {"values":{"textInput1":"","name1":"11","SECOND_CONTACT_PHONE":"","name":"22","name2122":"","sex":1,"FIRST_CONTACT_TYPE":"","FIRST_CONTACT_TYPE2":""},"errors":[{"name":"textInput1","message":"请填写姓名1"}]}"
            // 表单提交校验toaster展示
            if (errorInfo && errorInfo.errors && errorInfo.errors.length && Array.isArray(errorInfo.errors)) {
                const error = errorInfo.errors[0]
                if (error && error.hasOwnProperty('name') && error.name && error.hasOwnProperty('message')) {
                    this.$toast(error.message)
                }
            }
        },
        /**
     * 该方法可以跨过必填校验获取
     */
        getDemoDynamicForm() {
            // {"textInput1":"","name1":"11","SECOND_CONTACT_PHONE":"","name":"22","name2122":"","sex":1,"FIRST_CONTACT_TYPE":"","FIRST_CONTACT_TYPE2":""}
            console.log(this.$refs.demoDynamicForm.template.getInstanceData())
        },
    },
}
</script>
<style lang="scss" scoped>
    .wrap{
        position: relative;
        height: 100%;
    }
    .tabbar{
        position: absolute;
        bottom: 0;
    }
</style>
